import React, { useState, useEffect } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const HeroSlider = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const slides = [
        {
            id: 1,
            image: "https://images.unsplash.com/photo-1566231900271-8b6bcb8baea8",
            imageAlt: "Elegant outdoor wedding ceremony setup with white chairs arranged in rows, floral arch decorated with pink and white roses, and string lights overhead in garden setting",
            title: "Wedding Season Sale",
            subtitle: "20% Off on All Services",
            badge: "Limited Time"
        },
        {
            id: 2,
            image: "https://images.unsplash.com/photo-1733244738988-70b1f4b96c37",
            imageAlt: "Luxurious wedding reception hall with crystal chandeliers, round tables with white linens, gold chiavari chairs, and tall floral centerpieces with candles",
            title: "Premium Venues",
            subtitle: "Book Your Dream Location",
            badge: "Exclusive"
        },
        {
            id: 3,
            image: "https://images.unsplash.com/photo-1707190979549-12d938c0e5b3",
            imageAlt: "Professional wedding photographer capturing bride and groom during golden hour sunset with camera equipment and natural outdoor lighting",
            title: "Expert Photography",
            subtitle: "Capture Every Moment",
            badge: "Top Rated"
        }];


    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides?.length);
        }, 5000);

        return () => clearInterval(timer);
    }, [slides?.length]);

    const goToSlide = (index) => {
        setCurrentSlide(index);
    };

    const goToPrevious = () => {
        setCurrentSlide((prev) => (prev - 1 + slides?.length) % slides?.length);
    };

    const goToNext = () => {
        setCurrentSlide((prev) => (prev + 1) % slides?.length);
    };

    return (
        <div className="relative w-full h-48 md:h-64 lg:h-80 overflow-hidden rounded-2xl bg-card">
            {/* Slides */}
            <div className="relative w-full h-full">
                {slides?.map((slide, index) =>
                    <div
                        key={slide?.id}
                        className={`absolute inset-0 transition-opacity duration-700 ${index === currentSlide ? 'opacity-100' : 'opacity-0'}`
                        }>

                        <Image
                            src={slide?.image}
                            alt={slide?.imageAlt}
                            className="w-full h-full object-cover" />


                        {/* Overlay Gradient */}
                        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />

                        {/* Content */}
                        <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6 lg:p-8">
                            <div className="inline-block px-3 py-1 mb-2 rounded-full bg-accent text-accent-foreground text-xs md:text-sm font-medium">
                                {slide?.badge}
                            </div>
                            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-white mb-1 md:mb-2">
                                {slide?.title}
                            </h2>
                            <p className="text-sm md:text-base lg:text-lg text-white/90">
                                {slide?.subtitle}
                            </p>
                        </div>
                    </div>
                )}
            </div>
            {/* Navigation Arrows */}
            <button
                onClick={goToPrevious}
                className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm hover:bg-white/30 transition-all"
                aria-label="Previous slide">

                <Icon name="ChevronLeft" size={20} color="white" strokeWidth={2.5} />
            </button>
            <button
                onClick={goToNext}
                className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm hover:bg-white/30 transition-all"
                aria-label="Next slide">

                <Icon name="ChevronRight" size={20} color="white" strokeWidth={2.5} />
            </button>
            {/* Dots Navigation */}
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
                {slides?.map((_, index) =>
                    <button
                        key={index}
                        onClick={() => goToSlide(index)}
                        className={`w-2 h-2 rounded-full transition-all ${index === currentSlide ?
                                'bg-white w-6' : 'bg-white/50 hover:bg-white/70'}`
                        }
                        aria-label={`Go to slide ${index + 1}`}
                        aria-current={index === currentSlide} />

                )}
            </div>
        </div>);

};

export default HeroSlider;